<script>
import FormAddress from "@/components/profil/address/FormAddress.vue";
import ModalComponent from "@/components/Modal.vue";

export default {
  name: 'ModalAddress',
  components: {ModalComponent, FormAddress}
}
</script>

<template>
  <modal-component title="Ajouter une adresse">
    <template #header>
      <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
        Ajouter une adresse
      </h3>
    </template>
    <template #body>
      <form-address @close-modal="$emit('closeModal')" />
    </template>
  </modal-component>
</template>

